import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import SeoMeta from '../components/SeoMeta';
import '../styles/ServicesPage.css'; 
import '../styles/PageHero.css';

const services = [
    { id: 'criminal-law', title: 'Criminal Law', description: 'Legal defense for criminal charges. ' + 
        'Most Common Criminal Issues our Law Office Provides include: Criminal Law, Drug Crimes, Drunk Driving, ' + 
        'Felonies, Misdemeanors, Speeding and Moving Violations, White Collar Crime'},
    { id: 'family-law', title: 'Family Law', description: 'Legal matters related to family issues. ' + 
        'Most Common Family Issues our law office provides are: Adoptions, Child Custody and Visitation, ' + 
        'Child Support, Divorce, Guardianship, Paternity, Separations, Spousal Support or Alimony and other related issues.'},
    { id: 'property-law', title: 'Property Law', description: 'Property disputes and transactions.' + 
        ' Most Common Real Estate, Property and Housing Issues our Law Office Provides: Commercial Real Estate, ' + 
        'Condominiums and Cooperatives, Construction Disputes, Foreclosures, Landlord and Tenant, Mortgages ' +
        'Purchase and Sale of Residence, Title and Boundary Disputes, Zoning, Planning and Land Use ' },
    { id: 'corporate-law', title: 'Corporate and business Law', description: 'Corporate and business legal services.' + 
        'Most Common  corporate and Business Issues our Law Office Provides: Breach of Contract, Contract Drafting and Review, ' + 
        'Business Disputes, Corps, LLCs, Partnerships, etc, Buying and Selling a Business, Entertainment Law' },
    { id: 'tax-law', title: 'Tax Law', description: 'Handling tax-related legal matters.' + 
        'Most Common Tax Issues our Law Office Provides: Business Taxation, Income Tax Disputes, Payroll Tax Issues ' + 
        'Property Tax Appeals, Sales and Use Tax, Tax Audits and Investigations, Tax Planning and Compliance' + 
        ' Tax Penalties and Debt Relief' },
    { id: 'intellectual-property-law', title: 'Intellectual Property Law', description: 'Protecting intellectual properties.' +
        'Most Common Intellectual Property Issues our Law Office Provides: Copyright, Trade Secrets, Intellectual Property' + 
        ' Trademarks, Patents ' },
    { id: 'employment-law', title: 'Employment Law', description: 'Legal services for employment issues.' + 
        'Most Common Job or Employment Issues our Law Office Provides:- Disabilities, Employment Contracts, Employment Discrimination,' +
        ' Pensions and Benefits, Sexual Harassment, Wages and Overtime Pay, Workplace Disputes, Wrongful Termination and other related issues.'},
    { id: 'bankruptcy-law', title: 'Bankruptcy and Finance Law', description: 'Assistance with bankruptcy filings.' +
        'Most Common Bankruptcy & Finances Issues our law provides: Collections, Drafting Wills and Trusts, Consumer Bankruptcy' + 
        'Foreclosures, Consumer Credit, Income Tax, Contested Wills or Probate, Mortgages' },
    { id: 'personal-injury-law', title: 'Personal Injury Law', description: 'Legal representation for personal injuries.'+
        'Most Common Personal Injury Issues our Law office provides: Automobile Accidents, Medical Malpractice' +
        ' Dangerous Property/Buildings, Personal Injury, Defective Products, Wrongful Death' }
];

function ServicesPage() {
    return (
        <div>
            <SeoMeta
                title="Legal Services in Addis Ababa | Ziyad Attorneys"
                description="Explore criminal, family, property, business, tax, employment, intellectual property, finance, and personal injury legal services in Ethiopia."
            />
            <div
            className="about-hero page-photo-hero"  
            style={{ backgroundImage: 'url(o1p.png)', backgroundSize: 'cover', backgroundPosition: 'center' }}>
                <div className="contact-header">

                    <h1 className="page-header-title page-hero-title page-hero-lower-title">
                        Our <span className="highlight">Services</span>
                    </h1>

                </div>
            </div>

            <Container className="my-5">
                <Row>
                    {services.map(service => (
                        <Col md={6} lg={4} className="mb-4" key={service.id}>
                            <Card id={service.id} className="service-card h-100 shadow-sm">
                                <Card.Body>
                                    <Card.Title>{service.title}</Card.Title>
                                    <Card.Text>{service.description}</Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Container>
        </div>
    );
}

export default ServicesPage;
